import React, { useState } from "react";
import { faPlus, faSave, faTruck, faMotorcycle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import { Input } from "../../General/Input";
import { Spinner } from "../../Spinner";

export const SinUnidadAdd = ({ tipo_unidad_id, onAction, busqueda }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => { setShow(false); }
    const [numero_serie, setNumero_serie] = useState(busqueda);
    const [loading, setLoading] = useState(false);
    const { postVehiculos } = useUnidades();

    const saveUnidad = async (event) => {
        event.preventDefault();
        setLoading(true);
        let resp = await postVehiculos({ "numeroSerie": numero_serie, "tipo_unidad_id": tipo_unidad_id });

        if (resp.ok) {
            setLoading(false);
            handleClose();
            await onAction(event, resp.msg);
        } else {
            setLoading(false);
            return Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "info",
            });
        }
    }

    return (
        <>
            {loading && <Spinner />}
            <div className="d-flex justify-content-center p-2">
                <FontAwesomeIcon
                    icon={tipo_unidad_id === 4 ? faTruck: faMotorcycle}
                    className="fa-2x text-dark pb-2 mr-2 cursor"
                    onClick={handleShow}
                    title="Agregar unidad"
                />
                <FontAwesomeIcon
                    icon={faPlus}
                    className="fa text-success pb-2 mr-2 cursor"
                    onClick={handleShow}
                    title="Agregar unidad"
                />
            </div>

            <Modal
                show={show}
                onHide={handleClose}
                size="lg"
                backdrop="static"
                keyboard={false}
            >
                <form className="form-card" onSubmit={saveUnidad}>
                    <Modal.Header
                        closeButton
                    >
                        <Modal.Title>
                            CREAR UNIDAD
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row justify-content-between text-left">
                            <div className="form-group col-sm-6 flex-column d-flex">
                                {" "}
                                <Input
                                    name="numero_serie"
                                    id="numero_serie"
                                    onChange={(e) => {
                                        setNumero_serie(e.target.value);
                                    }
                                    }
                                    value={numero_serie}
                                    type="text"
                                    labelText={"Número de serie"}
                                    placeholder={"Escribe el número de serie de la unidad"}
                                    classNames="mb-4"
                                ></Input>{" "}
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="submit"
                            className="btn btn-lg"
                            style={{ background: "#ffcd00" }}
                        >
                            <FontAwesomeIcon icon={faSave} />
                            CREAR
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}